<template>
  <popup :showFlag="showFlag"
         @onShowpop="onShowpop">
    <div class="rd_ruletp" @click.stop="rf">
      <img @click="returnrule" mode="widthFix" src="@/assets/icon_del.png" class="delpng"/>
      <div class="name">{{name}}</div>
      <div class="actilistwrap">
        <div class="list">
          <div class="key">像素大小</div>
          <div class="val">{{width_px}} x {{height_px}} px</div>
        </div>
        <div class="list">
          <div class="key">分辨率</div>
          <div class="val">{{ppi ? ppi : 300}}DPI</div>
        </div>
        <div class="list">
          <div class="key">冲印尺寸</div>
          <div class="val">{{width_mm}} x {{height_mm}} mm</div>
        </div>
        <div class="list">
          <div class="key">文件大小</div>
          <div class="val">{{file_size_min|showSize(file_size_max)}}</div>
        </div>
        <div class="list">
          <div class="key">文件格式</div>
          <div class="val">{{photo_format}}</div>
        </div>
      </div>
      <div class="actititle">指定底色</div>
      <color-sel :color="background_color"
                 :coloridx="colorIdx"
                 :isleft="true"
                 @onSetidx="onSetidx"></color-sel>
      <div class="btn" @click="sureid">确认使用该规格</div>
    </div>
  </popup>
</template>

<script>
import popup from '../popup'
import colorSel from '@/components/colorSel/colorSel'
import { mapActions, mapMutations } from 'vuex'
export default {
  name: 'ruleDetail',
  data () {
    return {
      name: '',
      print: 1,
      width_mm: 0,
      height_mm: 0,
      width_px: 0,
      height_px: 0,
      file_size_max: 0,
      file_size_min: 0,
      ppi: 300,
      background_color: [],
      photo_format: 'jpg',
      remark: '',
      spec_id: 0,
      colorIdx: 0,
      returnRule: true // 判断点击×是否返回规格列表还是直接首页
    }
  },
  props: {
    showFlag: {
      type: Boolean,
      default: false
    },
    normal: {
      default: true, // 是否显示 支持电子照冲印信息以及规格详情
      type: Boolean
    }
  },
  destroyed () {
    console.log('ruledetail组件没有了')
    this.$bus.off('openActiwrap')
  },
  created () {
    this.$bus.off('openActiwrap')
    this.$bus.on('openActiwrap', this.openActiwrap)
  },
  methods: {
    ...mapActions(['getSpecDetailA']),
    ...mapMutations(['setMakePhotoInfo']),
    onSetidx (idx) {
      this.colorIdx = idx
    },
    returnrule () {
      const key = this.returnRule ? 'onReturnrule' : 'onControlRule'
      console.log(key)
      this.$emit(key)
    },
    openActiwrap (...args) {
      console.log(111)
      console.log(args)
      // 参数1为规格id，参数2为是否点击×直接返回首页
      const [specid, returnRule] = args
      console.log(returnRule)
      this.specid = specid
      this.getSpecDetailA(specid).then(res => {
        console.log(res)
        const obj = res.result
        const colorInfo = typeof obj.background_color === 'object' ? obj.background_color : JSON.parse(obj.background_color)
        const color = colorInfo.map(item => {
          return {
            start_color: item.start_color,
            enc_color: item.enc_color,
            s_color: item.start_color.toString(16).padStart(6, 0),
            e_color: item.enc_color.toString(16).padStart(6, 0),
            color_name: item.color_name
          }
        })
        obj.background_color = color
        obj.returnRule = returnRule
        obj.colorIdx = 0
        this.setData(obj)
      })
    },
    sureid () {
      const { spec_id, width_px, colorIdx, height_px, width_mm, height_mm, ppi, background_color, print, name, file_size_min, file_size_max, is_word } = this
      const obj = {
        spec_id,
        clothes_path: '',
        algo_fileuuid_origin: '',
        width_px,
        height_px,
        width_mm,
        height_mm,
        ppi,
        background_color,
        print,
        specName: name,
        colorIdx,
        file_size_min,
        file_size_max,
        is_word
      }
      this.setMakePhotoInfo(obj)
      this.$emit('onSureid')
    },
    setData (obj) {
      Object.keys(obj).forEach(item => {
        this[item] = obj[item]
      })
    },
    onShowpop () {
      this.$emit('onControlRule')
    },
    rf () {
      return false
    }
  },
  components: {
    popup,
    colorSel: colorSel
  },
  filters: {
    showSize (min, max) {
      return min && max ? `${parseInt(min / 1024)}~${parseInt(max / 1024)}KB` : min && !max ? `不小于${parseInt(min / 1024)}KB` : !min && max ? `不大于${parseInt(max / 1024)}KB` : '无要求'
    }
  }
}
</script>

<style scoped>
.rd_ruletp{
  background-color: #F7F7F7;
  padding:.64rem .32rem 0;
  box-sizing: border-box;
  border-top-left-radius: .48rem;
  border-top-right-radius: .48rem;
  height: 7.64rem;
  position:relative;
}
.delpng{
  width:.42rem;
  height:.42rem;
  position: absolute;
  right:.22rem;
  top:.22rem;
  border:.1rem solid transparent;
}
.actilistwrap{
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  border-bottom:.02rem solid #E5E5EA;
  padding-bottom: .08rem;
}
.name{
  font-size: .4rem;
  font-weight: bold;
  color:#303133;
  margin-bottom: .32rem;
  border-bottom:.02rem solid #E5E5EA;
  padding-bottom: .32rem;
}
.eleprint{
  display: flex;
  display: -webkit-flex;
  font-size: .24rem;
  color:#303133;
  align-items: center;
  height: .3rem;
}
.yesno{
  width:.32rem;
  height:.32rem;
  margin-right: .16rem;
  font-size: 0;
}
.ml{
  margin-left: .24rem;
}
.fs0{
  flex-shrink: 0;
}
.detailTitle{
  font-size: .34rem;
  font-weight: bold;
  color:#303133;
  margin: .48rem 0 .26rem;
  padding-top: .48rem;
  border-top:.02rem solid rgba(0,0,0,0.28);
}
.list{
  font-size: .26rem;
  color:#303133;
  display: flex;
  display: -webkit-flex;
  margin-bottom: .24rem;
  width:50%;
}
.key{
  width: 1.2rem;
  margin-right: .12rem;
  flex-shrink: 0;
}
.val{
  word-break: break-all;
}
.colorwrap{
  display: flex;
  display: -webkit-flex;
}
.color{
  width:.24rem;
  height:.24rem;
  border-radius: 50%;
  margin-right: .2rem;
  box-sizing: border-box;
  flex-shrink: 0;
  flex-grow: 0;
}
.bg{
  border:.02rem solid #E9E9E9;
}
.btn{
  height:.88rem;
  border-radius: .12rem;
  font-size: .34rem;
  color:#ffffff;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  background-color: #4710ED;
  position: absolute;
  width:6.86rem;
  bottom:.48rem;
}
.activebtn{
  background-color: rgba(71,16,237,0.5)
}
.actititle{
  font-size: .28rem;
  color:#303133;
  margin:.32rem 0;
  font-weight: bold;
}
</style>
